import { UseAuthSessionProps } from "~/services/oauth"
import { FacetType } from "~/types"

import { GetFacetsParams } from "./facet"

export const ENTITY = "ENTITY"
export const ENTITY_ID_BY_ORGANIZATION = "ENTITY_ID_BY_ORGANIZATION"
export const FACETS = "FACETS"
export const COUNTRIES = "COUNTRIES"
export const PROGRAM_BY_ID = "PROGRAM_BY_ID"
export const PROGRAM_BY_SLUG = "PROGRAM_BY_SLUG"
export const CURRENCIES = "CURRENCIES"
export const DEFAULT_LOOKUP_SOURCE = "DEFAULT_LOOKUP_SOURCE"
export const FILE_METADATA = "FILE_METADATA"
export const THEMES = "THEMES"
export const HISTORY = "HISTORY"
export const SETUP_AUTH_SESSION = "SETUP_AUTH_SESSION"
export const AUTH_SESSION = "AUTH_SESSION"

export const queryKeys = {
  entity: (entityId: number | undefined, facetType: FacetType) => [ENTITY, entityId, facetType],
  entityIdByOrganization: (organizationId: number | undefined) => [ENTITY_ID_BY_ORGANIZATION, organizationId],
  facets: (params?: GetFacetsParams) => [
    FACETS,
    {
      names: params?.names?.join(","),
      profile_ids: params?.profile_ids?.join(","),
      language: params?.language,
    },
  ],
  countries: (params?: URLSearchParams) => (params ? [COUNTRIES, params.toString()] : [COUNTRIES]),
  currencies: () => [CURRENCIES],
  themes: () => [THEMES],
  programById: (programId?: string) => [PROGRAM_BY_ID, programId],
  programBySlug: (programSlug?: string) => [PROGRAM_BY_SLUG, programSlug],
  defaultLookupSource: () => [DEFAULT_LOOKUP_SOURCE],
  fileMetadata: (id?: string) => [FILE_METADATA, id],
  history: (entityFacetId?: number) => [HISTORY, entityFacetId],
  setupAuthSession: ({ code }: UseAuthSessionProps) => [SETUP_AUTH_SESSION, code],
  authSession: () => [AUTH_SESSION],
}
